document.addEventListener("DOMContentLoaded", function () {
  const filtroProdutos = document.querySelector(".filtros-anuncios");
  if (filtroProdutos != null) {
    // Máscara para campos de preço
    const camposDinheiro = document.querySelectorAll(".mascara-dinheiro");
    if (camposDinheiro.length > 0) {
      camposDinheiro.forEach(function (campo) {
        campo.addEventListener("input", function (e) {
          // Remove tudo que não é número
          let valor = e.target.value.replace(/\D/g, "");

          // Converte para decimal (divide por 100)
          valor = (valor / 100).toFixed(2);

          // Formata com R$ e separadores
          valor = valor.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");

          e.target.value = valor;
        });
      });
    }

    // Validar intervalo de anos (ano inicial não pode ser maior que o final)
    const anoInicio = document.getElementById("anoInicio");
    const anoFim = document.getElementById("anoFim");

    anoInicio.addEventListener("change", function () {
      if (anoFim.value && parseInt(this.value) > parseInt(anoFim.value)) {
        alert("O ano inicial não pode ser maior que o ano final");
        this.value = "";
      }
    });

    anoFim.addEventListener("change", function () {
      if (anoInicio.value && parseInt(this.value) < parseInt(anoInicio.value)) {
        alert("O ano final não pode ser menor que o ano inicial");
        this.value = "";
      }
    });

    $(document).ready(function () {
      function atualizaDiv() {
        var valor = $("#selectMoeda").val();
        if (valor === "brl" || valor === "") {
          $("#filtroPreco").stop(true, true).slideDown("slow");
        } else {
          $("#filtroPreco").stop(true, true).slideUp("slow");
        }
      }

      // Executa na troca do select
      $("#selectMoeda").on("change", function () {
        atualizaDiv();
      });

      // Executa no carregamento da página (depois do submit)
      atualizaDiv();
    });
  }
});

$(".btn-filtros-mb").click(function () {
  $(".filtros-anuncios").toggle("slow");
});

$(document).ready(function () {
  // Funcao principal que carrega as subcategorias via AJAX

  const loadSubcategorias = function (categoriaID) {
    var $selectSubcategoria = $("#selectModelo");
    const subcategoriaIDSelecionada = $("#marcaId").data("modelo");

    // Limpa e desabilita enquanto carrega
    $selectSubcategoria
      .html('<option value="">Carregando...</option>')
      .prop("disabled", true);

    if (categoriaID) {
      $.ajax({
        url: url_base + "acoes/api/busca_modelos.php", // O script PHP que buscará no BD
        type: "POST",
        data: { categoria_id: categoriaID },
        dataType: "json",
        success: function (subcategorias) {
          $selectSubcategoria.html(
            '<option value="">Selecione um modelo</option>'
          );

          if (subcategorias.length > 0) {
            $.each(subcategorias, function (i, subcat) {
              $selectSubcategoria.append(
                $("<option></option>").val(subcat.id).text(subcat.titulo)
              );
            });
            $selectSubcategoria.prop("disabled", false);

            if (subcategoriaIDSelecionada && subcategoriaIDSelecionada !== "") {
              $selectSubcategoria.val(subcategoriaIDSelecionada);
            }
          } else {
            $selectSubcategoria
              .html('<option value="">Nenhuma modelo encontrado</option>')
              .prop("disabled", true);
          }
        },
        error: function () {
          $selectSubcategoria.html(
            '<option value="">Erro ao carregar dados</option>'
          );
        },
      });
    } else {
      $selectSubcategoria
        .html('<option value="">Selecione uma marca</option>')
        .prop("disabled", true);
    }
  };

  $("#selectMarca")
    .on("change", function () {
      const categoriaID = $(this).val();
      loadSubcategorias(categoriaID);
    })
    .trigger("change");
});
